import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Home, GraduationCap, Check } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-12 md:py-16" style={{
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <FadeIn data-id="element-3">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" style={{
          color: 'var(--color-deep-blue)'
        }} data-id="element-4">
            Diseñado para quienes enseñan con amor
          </h2>
        </FadeIn>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-5">
          {/* Families */}
          <FadeIn delay={0.1} data-id="element-6">
            <div className="bg-white rounded-2xl p-8 shadow-sm border h-full transition-transform hover:-translate-y-1 duration-300" style={{
            borderColor: 'var(--color-border)'
          }} data-id="element-7">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6" style={{
              backgroundColor: '#FDF2EC'
            }} data-id="element-8">
                <Home className="w-7 h-7" style={{
                color: 'var(--color-soft-peach)'
              }} data-id="element-9" />
              </div>
              <h3 className="text-xl font-bold mb-5" style={{
              color: 'var(--color-deep-blue)'
            }} data-id="element-10">
                Ideal para familias cristianas
              </h3>
              <ul className="space-y-4" data-id="element-11">
                {['Perfecto para el tiempo de devocional en familia antes de dormir.', 'Una alternativa sana y con valores para reemplazar el tiempo de pantallas.', 'Herramientas simples para enseñar sobre Dios en casa sin ser expertos.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-12">
                    <Check className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-13" />
                    <span className="text-base font-medium" style={{
                  color: 'var(--color-body)'
                }} data-id="element-14">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Teachers */}
          <FadeIn delay={0.2} data-id="element-15">
            <div className="bg-white rounded-2xl p-8 shadow-sm border h-full transition-transform hover:-translate-y-1 duration-300" style={{
            borderColor: 'var(--color-border)'
          }} data-id="element-16">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6" style={{
              backgroundColor: '#EAF2F8'
            }} data-id="element-17">
                <GraduationCap className="w-7 h-7" style={{
                color: 'var(--color-soft-blue)'
              }} data-id="element-18" />
              </div>
              <h3 className="text-xl font-bold mb-5" style={{
              color: 'var(--color-deep-blue)'
            }} data-id="element-19">
                Ideal para docentes y catequistas
              </h3>
              <ul className="space-y-4" data-id="element-20">
                {['Recursos listos para imprimir y usar en la escuela dominical o el aula.', 'Actividades dinámicas que mantienen a los niños entretenidos y aprendiendo.', 'Cubre múltiples temáticas bíblicas para planificar clases todo el año.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-21">
                    <Check className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-22" />
                    <span className="text-base font-medium" style={{
                  color: 'var(--color-body)'
                }} data-id="element-23">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}